import { render, staticRenderFns } from "./ServiceItem.vue?vue&type=template&id=9b460e66"
import script from "./ServiceItem.vue?vue&type=script&lang=js"
export * from "./ServiceItem.vue?vue&type=script&lang=js"
import style0 from "./ServiceItem.vue?vue&type=style&index=0&id=9b460e66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports